import { ShopType, CheckoutType, MultiProviderConfig } from 'types';
import { asyncEligible } from 'config';
import { ProviderConfigList } from 'config/providers';
import { ShopLikeSamTheme } from 'config/themes';

export const ShopLikeSamIFramed: MultiProviderConfig = {
  name: 'ShopLikeSamIFramed',
  displayName: 'ShopLikeSam',
  micrositeCode: 'ShopLikeSamIFrame',
  shopType: ShopType.MULTI_PROVIDER,
  domain: 'updater.com',
  homepage: '',
  enableMicrositeLanding: false,
  title: 'Compare and shop for internet & TV with ShopLikeSam',
  fallbackPhoneNumber: '844-715-1565',
  fallbackLeadModePhoneNumber: '844-715-1566',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: ShopLikeSamTheme,
  needsDcSession: false,
  updaterCrossSellActive: false,
  source: 'ShopLikeSamIFrame',
  noOffersRetry: 2,
  //Suppress EarthLink and TDS
  providers: ProviderConfigList.filter(
    (provider) =>
      provider.providerCode !== 'earthlink' && provider.providerCode !== 'tds'
  ),
  movingAppBuyflowUrls: {
    development: 'http://bridgevine.io:3000/guest/tvi/buy',
    staging: 'https://staging-partner-cart.updater.com/guest/tvi/buy',
    qa: 'https://staging-partner-cart.updater.com/guest/tvi/buy',
    production: 'https://partner-cart.updater.com/guest/tvi/buy',
  },
  getCheckoutType: asyncEligible,
  iFrameConfig: {
    hideHeaderAndFooter: true,
    trustedHosts: {
      production: ['shoplikesam.com'],
    },
  },
};
